// import { defaultWagmiConfig } from "@web3modal/wagmi/react/config";
import { polygon, sepolia } from "wagmi/chains";
import { QueryClient } from "@tanstack/react-query";
import { createConfig, http } from "wagmi";
import { walletConnect, injected, coinbaseWallet } from "wagmi/connectors";

export const queryClient = new QueryClient();

const projectId = process.env.REACT_APP_WAGMI_PROJECT_ID || "YOUR_PROJECT_ID";

const metadata = {
  name: "Ecomoto",
  description: "Ecomoto Connect",
  url: "http://beta.ecomoto.io", // origin must match your domain & subdomain
  icons: [
    "https://res.cloudinary.com/dicsazvfz/image/upload/v1695721086/logo_2_jqzkji.png",
  ],
};

const chains = [
  process.env.REACT_APP_ENVIRONMENT === "dev" ? sepolia : polygon,
] as const;

export const wagmiConfig = createConfig({
  chains,
  transports: {
    [sepolia.id]: http(process.env.REACT_APP_ALCHEMY_URL),
    [polygon.id]: http(process.env.REACT_APP_ALCHEMY_URL),
  },
  connectors: [
    walletConnect({ projectId, metadata, showQrModal: false }),
    injected({ shimDisconnect: true }),
    coinbaseWallet({
      appName: metadata.name,
      appLogoUrl: metadata.icons[0],
    }),
  ],
});

// export const wagmiConfig = defaultWagmiConfig({
//   chains,
//   projectId,
//   metadata,
// });
